// get params from urll will return the desired query string value by id
export const getParamsFromUrl = (id: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.has(id) ? params.get(id) : null;
};
